/* eslint-disable react/no-danger */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getCurrencySymbol } from '@/utils/currency';
import { BookingCost, Location } from '@core/booking/booking.types';

export interface BookingSummaryProps {
  bookingCost?: BookingCost;
  selectedLocation: Location;
}

const BookingSummary: FC<BookingSummaryProps> = ({ bookingCost, selectedLocation }) => {
  const { t } = useTranslation();
  const currencySymbol = getCurrencySymbol(bookingCost?.currency, selectedLocation);

  if (!bookingCost) {
    return null;
  }
  return (
    <div
      className="flex justify-between w-full md:w-1/2 px-10 py-5 md:p-6 text-xl md:text-4xl font-bold absolute start-0 md:start-1/4"
      style={{ zIndex: 1000 }}
    >
      <div>
        <span style={{ color: '#404D61' }}>{t('booking.summary.subTotal')}</span>
        <br />
        <span
          className="text-secondary"
          dangerouslySetInnerHTML={{
            __html: `${currencySymbol}${bookingCost.subTotal?.toFixed(2) || 0}`,
          }}
        />
      </div>
      {!!bookingCost.vat && (
        <div>
          <span style={{ color: '#404D61' }}>{t('booking.summary.vat')}</span>
          <br />
          <span className="text-error">{`${bookingCost.vat || 0}%`}</span>
        </div>
      )}
      <div>
        <span style={{ color: '#404D61' }}>{t('booking.summary.total')}</span>
        <br />
        <span
          className="text-main"
          dangerouslySetInnerHTML={{
            __html: `${currencySymbol}${bookingCost.total?.toFixed(2) || 0}`,
          }}
        />
      </div>
    </div>
  );
};

export default BookingSummary;
